/* Shunya theme JS: AJAX cart drawer + mobile nav (Task 5) */
window.Shunya = window.Shunya || {};

(function (S) {
  'use strict';

  /* ─── Money helper ──────────────────────────────────────────────────────── */
  function formatMoney(cents) {
    var fmt = window.moneyFormat || '₹{{amount}}';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, fmt);
    }
    var amount = (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    // Match the store's money format (e.g. "Rs. {{amount}}") instead of a
    // hard-coded symbol, so the JS-rendered cart matches the rest of the site.
    if (/\{\{\s*amount/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
    }
    return '₹' + amount;
  }

  /* ─── Safe querySelector wrapper ────────────────────────────────────────── */
  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  /* ══════════════════════════════════════════════════════════════════════════
     Shunya.Cart
  ══════════════════════════════════════════════════════════════════════════ */
  var Cart = (function () {
    var _lastCart = null; // cached last cart JSON

    /* SVG close icon replicated for remove buttons (plain × text fallback) */
    function closeIcon() {
      return '<span aria-hidden="true" style="pointer-events:none;">&#x2715;</span>';
    }

    /* Build item rows HTML ─────────────────────────────────────────────── */
    function buildItems(items) {
      return items.map(function (item) {
        var imgSrc = item.image
          ? item.image.replace(/(\.\w+)(\?|$)/, '_120x$1$2')
          : '';
        var imgTag = imgSrc
          ? '<img src="' + imgSrc + '" alt="' + escAttr(item.product_title) + '" width="62" height="80" loading="lazy">'
          : '';

        return (
          '<div class="shunya-cart-drawer__item">' +
            '<div class="shunya-cart-drawer__item-image frame">' +
              imgTag +
            '</div>' +
            '<div class="shunya-cart-drawer__item-details">' +
              '<div class="shunya-cart-drawer__item-top">' +
                '<div>' +
                  '<div class="shunya-cart-drawer__item-name">' + esc(item.product_title) + '</div>' +
                  '<div class="shunya-cart-drawer__item-size">Size ' + esc(item.variant_title || '') + '</div>' +
                '</div>' +
                '<button class="shunya-cart-drawer__item-remove" aria-label="Remove ' + escAttr(item.product_title) + '" data-cart-remove data-key="' + escAttr(item.key) + '">' +
                  closeIcon() +
                '</button>' +
              '</div>' +
              '<div class="shunya-cart-drawer__item-bottom">' +
                '<div class="shunya-cart-drawer__qty-control">' +
                  '<button class="shunya-cart-drawer__qty-btn" aria-label="Decrease quantity" data-qty-dec data-key="' + escAttr(item.key) + '">&#8722;</button>' +
                  '<span class="shunya-cart-drawer__qty-val">' + item.quantity + '</span>' +
                  '<button class="shunya-cart-drawer__qty-btn" aria-label="Increase quantity" data-qty-inc data-key="' + escAttr(item.key) + '">&#43;</button>' +
                '</div>' +
                '<span class="shunya-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    /* Build footer HTML ───────────────────────────────────────────────── */
    function buildFooter(cart) {
      return (
        '<div class="shunya-cart-drawer__footer">' +
          '<div class="shunya-cart-drawer__subtotal-row">' +
            '<span class="shunya-cart-drawer__subtotal-label">Subtotal</span>' +
            '<span class="shunya-cart-drawer__subtotal-val" data-cart-subtotal>' + formatMoney(cart.total_price) + '</span>' +
          '</div>' +
          '<p class="shunya-cart-drawer__tax-note">Taxes &amp; shipping calculated at checkout.</p>' +
          '<a href="/checkout" class="shunya-cart-drawer__checkout-btn btn btn--solid">Proceed to checkout</a>' +
          '<button class="shunya-cart-drawer__continue-btn" data-cart-close>Continue shopping</button>' +
        '</div>'
      );
    }

    /* HTML escape helpers ─────────────────────────────────────────────── */
    function esc(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
    function escAttr(str) {
      return esc(str).replace(/"/g, '&quot;');
    }

    /* ── Public API ────────────────────────────────────────────────────── */

    function render(cart) {
      _lastCart = cart;

      // Update badge count
      var badge = qs('[data-cart-count]');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count === 0 ? 'none' : '';
      }

      // Rebuild cart body
      var body = qs('[data-cart-items]');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML =
          '<div class="shunya-cart-drawer__empty">' +
            '<span class="shunya-cart-drawer__empty-odia">शून्य</span>' +
            '<p class="shunya-cart-drawer__empty-text">Your cart holds emptiness</p>' +
            '<a href="/collections/all" class="shunya-cart-drawer__empty-cta" data-cart-close>Fill it with heritage</a>' +
          '</div>';
      } else {
        body.innerHTML =
          '<div class="shunya-cart-drawer__items">' +
            buildItems(cart.items) +
          '</div>';
      }

      // Render footer into its dedicated container so it can never duplicate
      // the server-rendered Liquid footer.
      var footer = qs('[data-cart-footer]');
      if (footer) {
        footer.innerHTML = cart.item_count === 0 ? '' : buildFooter(cart);
      }
    }

    function refresh() {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); })
        .catch(function () { /* silent on pages without a cart */ });
    }

    function add(id, qty) {
      qty = qty === undefined ? 1 : qty;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      })
        .then(function () { return refresh(); })
        .then(function () { open(); });
    }

    function change(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); })
        .catch(function () { /* silent */ });
    }

    function open() {
      var drawer = qs('[data-cart-drawer]');
      var overlay = qs('[data-cart-overlay]');
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      var drawer = qs('[data-cart-drawer]');
      var overlay = qs('[data-cart-overlay]');
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    /* ── Event delegation ──────────────────────────────────────────────── */
    document.addEventListener('click', function (e) {
      var target = e.target;

      // Walk up to find the delegated element (handles icon children)
      function closest(el, attr) {
        while (el && el !== document) {
          if (el.hasAttribute && el.hasAttribute(attr)) return el;
          el = el.parentNode;
        }
        return null;
      }

      if (closest(target, 'data-cart-open')) {
        e.preventDefault();
        open();
        return;
      }

      if (closest(target, 'data-cart-close')) {
        close();
        return;
      }

      if (closest(target, 'data-cart-overlay')) {
        close();
        return;
      }

      var decBtn = closest(target, 'data-qty-dec');
      if (decBtn) {
        var keyDec = decBtn.getAttribute('data-key');
        var currentQtyDec = _lastCart
          ? (_lastCart.items.find(function (i) { return i.key === keyDec; }) || {}).quantity || 1
          : 1;
        change(keyDec, Math.max(0, currentQtyDec - 1));
        return;
      }

      var incBtn = closest(target, 'data-qty-inc');
      if (incBtn) {
        var keyInc = incBtn.getAttribute('data-key');
        var currentQtyInc = _lastCart
          ? (_lastCart.items.find(function (i) { return i.key === keyInc; }) || {}).quantity || 0
          : 0;
        change(keyInc, currentQtyInc + 1);
        return;
      }

      var removeBtn = closest(target, 'data-cart-remove');
      if (removeBtn) {
        var keyRem = removeBtn.getAttribute('data-key');
        change(keyRem, 0);
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    document.addEventListener('DOMContentLoaded', function () {
      refresh();
    });

    return { refresh: refresh, add: add, change: change, render: render, open: open, close: close };
  })();

  S.Cart = Cart;

  /* ══════════════════════════════════════════════════════════════════════════
     Shunya.MobileNav
  ══════════════════════════════════════════════════════════════════════════ */
  var MobileNav = (function () {
    function init() {
      var toggle = qs('[data-nav-toggle]');
      var menu = qs('[data-mobile-menu]');

      if (!toggle || !menu) return;

      // Open the menu directly beneath the header (announcement bar + header
      // stay visible; no orphaned strip or overlap regardless of scroll).
      function positionMenu() {
        var header = document.querySelector('.shunya-header');
        menu.style.top = (header ? Math.round(header.getBoundingClientRect().bottom) : 0) + 'px';
      }

      toggle.addEventListener('click', function () {
        var isOpen = menu.classList.contains('is-open');
        if (isOpen) {
          menu.classList.remove('is-open');
          document.body.style.overflow = '';
        } else {
          positionMenu();
          menu.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      });

      // Close when a link inside is clicked
      menu.addEventListener('click', function (e) {
        if (e.target && e.target.tagName === 'A') {
          menu.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });

      // Close on Escape key
      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && menu.classList.contains('is-open')) {
          menu.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }

    document.addEventListener('DOMContentLoaded', init);

    return { init: init };
  })();

  S.MobileNav = MobileNav;

})(window.Shunya);

/* ══════════════════════════════════════════════════════════════════════════
   Shunya.CollectionFilter  (Task 7)
   Filters [data-product-card] elements by matching data-tags against the
   clicked [data-filter-tab] value. Guards against pages without tabs.
══════════════════════════════════════════════════════════════════════════ */
(function (S) {
  'use strict';

  var CollectionFilter = (function () {
    function init() {
      var tabs = document.querySelectorAll('[data-filter-tab]');
      if (!tabs || tabs.length === 0) return; // no filter tabs on this page

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          // Toggle active class across the tab group
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');

          var v = tab.getAttribute('data-filter-tab');
          var cards = document.querySelectorAll('[data-product-card]');
          var visible = 0;

          cards.forEach(function (card) {
            var show;
            if (v === 'all') {
              show = true;
            } else {
              var tagStr = card.getAttribute('data-tags') || '';
              var tags = tagStr.split(',').map(function (t) { return t.trim(); });
              show = tags.indexOf(v) !== -1;
            }
            card.style.display = show ? '' : 'none';
            if (show) { visible++; }
          });

          var grid = document.querySelector('.shunya-collection-grid__grid');
          if (grid) {
            var empty = grid.querySelector('[data-filter-empty]');
            if (visible === 0) {
              if (!empty) {
                empty = document.createElement('p');
                empty.className = 'shunya-filter-empty';
                empty.setAttribute('data-filter-empty', '');
                grid.appendChild(empty);
              }
              empty.textContent = 'No pieces in this category yet. Try another thread.';
              empty.style.display = '';
            } else if (empty) {
              empty.style.display = 'none';
            }
          }
        });
      });
    }

    document.addEventListener('DOMContentLoaded', init);

    return { init: init };
  })();

  S.CollectionFilter = CollectionFilter;

})(window.Shunya);

/* ══════════════════════════════════════════════════════════════════════════
   Shunya.Product  (Task 11b)
   Variant selection, gallery, qty stepper, add-to-cart (AJAX), accordions.
   Guards against non-product pages (no [data-product-variants] = early exit).
══════════════════════════════════════════════════════════════════════════ */
(function (S) {
  'use strict';

  var Product = (function () {

    /* ── Money helper ──────────────────────────────────────────────────── */
    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, window.moneyFormat || '₹{{amount}}');
      }
      return '₹' + (cents / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    /* ── Walk-up closest helper (no Element.closest polyfill needed in modern
          Shopify themes, but we also need attr-based matching) ─────────── */
    function closestAttr(el, attr) {
      while (el && el !== document) {
        if (el.hasAttribute && el.hasAttribute(attr)) return el;
        el = el.parentNode;
      }
      return null;
    }

    /* ── State ─────────────────────────────────────────────────────────── */
    var variants    = [];   // parsed from JSON blob
    var selected    = {};   // { "1": "S", "2": "Black", … }  keyed by option-position string
    var resolvedId  = null; // currently matched variant id (or null)
    var qty         = 1;

    /* ── Resolve variant from current selected map ─────────────────────── */
    function resolveVariant() {
      var positions = Object.keys(selected).sort(); // ["1","2","3"]
      return variants.find(function (v) {
        return positions.every(function (pos) {
          var idx = Number(pos) - 1; // options array is 0-indexed
          return v.options[idx] === selected[pos];
        });
      }) || null;
    }

    /* ── Update price display ───────────────────────────────────────────── */
    function updatePrice(variant) {
      var priceEl   = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare-price]');
      var saveEl    = document.querySelector('[data-save]');

      if (!priceEl) return;

      if (!variant) {
        // leave price as-is when no variant matched
        return;
      }

      priceEl.textContent = formatMoney(variant.price);

      if (compareEl && saveEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
          var savePct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          saveEl.textContent = '-' + savePct + '%';
          saveEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
          saveEl.textContent = '';
          saveEl.hidden = true;
        }
      }
    }

    /* ── Update add-to-cart button state ───────────────────────────────── */
    function updateButton(variant) {
      var btn      = document.querySelector('[data-add-to-cart]');
      var labelEl  = document.querySelector('[data-add-label]');
      if (!btn || !labelEl) return;

      if (!variant) {
        btn.disabled = true;
        labelEl.textContent = 'Unavailable';
      } else if (variant.available) {
        btn.disabled = false;
        labelEl.textContent = 'Add to cart';
      } else {
        btn.disabled = true;
        labelEl.textContent = 'Sold out';
      }
    }

    /* ── After any option change: resolve + update UI ───────────────────── */
    function afterOptionChange() {
      var variant = resolveVariant();
      resolvedId  = variant ? variant.id : null;
      updatePrice(variant);
      updateButton(variant);

      // Update the hidden variant id input
      var idInput = document.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant ? variant.id : '';
    }

    /* ── Read initial selection from .is-selected buttons ──────────────── */
    function readInitialSelection() {
      var groups = document.querySelectorAll('[data-option-group]');
      groups.forEach(function (group) {
        var pos = group.getAttribute('data-option-position');
        // Find the selected button in this group, fall back to first button
        var selectedBtn = group.querySelector('[data-option-value].is-selected') ||
                          group.querySelector('[data-option-value]');
        if (selectedBtn) {
          selected[pos] = selectedBtn.getAttribute('data-value');
        }
      });
    }

    /* ── Option click handler ───────────────────────────────────────────── */
    function onOptionClick(e) {
      var btn = closestAttr(e.target, 'data-option-value');
      if (!btn) return;

      // Find the parent group, use this for position (inner forloop index on
      // buttons is the value-index, not the option-index; group div is correct)
      var group = closestAttr(btn, 'data-option-group');
      if (!group) return;

      var pos = group.getAttribute('data-option-position');

      // Move is-selected within this group
      var siblings = group.querySelectorAll('[data-option-value]');
      siblings.forEach(function (s) { s.classList.remove('is-selected'); });
      btn.classList.add('is-selected');

      // Update selection map
      selected[pos] = btn.getAttribute('data-value');

      // Hide error
      var errEl = document.querySelector('[data-option-error]');
      if (errEl) errEl.hidden = true;

      afterOptionChange();
    }

    /* ── Gallery ────────────────────────────────────────────────────────── */
    function onThumbClick(e) {
      var thumb = closestAttr(e.target, 'data-thumb');
      if (!thumb) return;

      var mainImg = document.querySelector('[data-main-image]');
      if (mainImg) mainImg.src = thumb.getAttribute('data-image');

      // Toggle is-active on thumbs
      document.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    }

    /* ── Qty stepper ────────────────────────────────────────────────────── */
    function updateQtyDisplay() {
      var qtyEl = document.querySelector('[data-pdp-qty]');
      if (qtyEl) qtyEl.textContent = String(qty);
    }

    function onQtyClick(e) {
      var dec = closestAttr(e.target, 'data-pdp-qty-dec');
      var inc = closestAttr(e.target, 'data-pdp-qty-inc');
      if (dec) {
        qty = Math.max(1, qty - 1);
        updateQtyDisplay();
      } else if (inc) {
        qty = qty + 1;
        updateQtyDisplay();
      }
    }

    /* ── Add to cart ────────────────────────────────────────────────────── */
    function onFormSubmit(e) {
      e.preventDefault();

      var errEl = document.querySelector('[data-option-error]');
      var btn   = document.querySelector('[data-add-to-cart]');

      // Check all option groups have a selection
      var groups   = document.querySelectorAll('[data-option-group]');
      var allChosen = true;
      groups.forEach(function (group) {
        var pos = group.getAttribute('data-option-position');
        if (!selected[pos]) allChosen = false;
      });

      if (!resolvedId || !allChosen) {
        if (errEl) errEl.hidden = false;
        return;
      }

      if (errEl) errEl.hidden = true;

      // Delegate to Cart module
      S.Cart.add(Number(resolvedId), qty);

      // Success feedback on button
      if (btn) {
        btn.classList.add('is-added');
        var labelEl = btn.querySelector('[data-add-label]');
        if (labelEl) labelEl.textContent = 'Added ✓';
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (labelEl) {
            var variant = resolveVariant();
            labelEl.textContent = (variant && !variant.available) ? 'Sold out' : 'Add to cart';
          }
        }, 2200);
      }
    }

    /* ── Accordions ─────────────────────────────────────────────────────── */
    function onAccordionClick(e) {
      var toggle = closestAttr(e.target, 'data-accordion-toggle');
      if (!toggle) return;

      // Body is always the immediate nextElementSibling of the toggle button
      var body = toggle.nextElementSibling;
      if (!body || !body.hasAttribute('data-accordion-body')) return;

      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      var signEl = toggle.querySelector('[data-accordion-sign]');

      if (isOpen) {
        body.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        if (signEl) signEl.textContent = '+';
      } else {
        body.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        if (signEl) signEl.textContent = '−'; // − minus sign
      }
    }

    /* ── Init ───────────────────────────────────────────────────────────── */
    function init() {
      var variantScript = document.querySelector('[data-product-variants]');
      if (!variantScript) return; // not a product page

      // Parse variants JSON
      try {
        variants = JSON.parse(variantScript.textContent);
      } catch (err) {
        return; // malformed JSON, bail out
      }

      // Read initial selection from pre-selected buttons
      readInitialSelection();

      // Bind option clicks (delegation on document)
      document.addEventListener('click', onOptionClick);

      // Gallery thumb clicks
      document.addEventListener('click', onThumbClick);

      // Qty stepper
      document.addEventListener('click', onQtyClick);

      // Accordion toggles
      document.addEventListener('click', onAccordionClick);

      // Form submit: intercept add-to-cart only
      var form = document.getElementById('product-form');
      if (form) form.addEventListener('submit', onFormSubmit);

      // Run initial resolve so price/button reflects the pre-selected variant
      afterOptionChange();
    }

    document.addEventListener('DOMContentLoaded', init);

    return { init: init };
  })();

  S.Product = Product;

})(window.Shunya);
